<template>
  <section class="performance-report">
    <header class="report-detail-header">
      <button type="button" class="back-button" @click="$router.go(-1)"><i class="fas fa-arrow-left"></i></button>
      <div><span class="eyebrow">Relatório da automação</span><h2>Desempenho da jornada</h2><p>Acompanhe a interação dos contatos com as mensagens automáticas.</p></div>
      <button type="button" class="refresh-button" :disabled="loading" @click="getTrackingAuto"><i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i> Atualizar</button>
    </header>

    <div v-if="loading" class="report-skeleton"><content-loading><fake-line height="30" /><fake-line height="30" /><fake-line height="30" /><fake-line height="30" /></content-loading></div>

    <template v-else>
      <div class="summary-grid">
        <article class="summary-card accent-purple"><div class="summary-icon"><i class="far fa-paper-plane"></i></div><span>Total de envios</span><strong>{{ stats.total | number }}</strong><small>Mensagens processadas</small></article>
        <article class="summary-card accent-blue"><div class="summary-icon"><i class="far fa-envelope-open"></i></div><span>Taxa de abertura</span><strong>{{ stats.tax_open | number }}%</strong><small>{{ stats.total_open | number }} aberturas</small></article>
        <article class="summary-card accent-pink"><div class="summary-icon"><i class="fas fa-mouse-pointer"></i></div><span>Taxa de clique</span><strong>{{ stats.tax_click | number }}%</strong><small>{{ stats.total_click | number }} cliques</small></article>
        <article class="summary-card accent-green"><div class="summary-icon"><i class="fas fa-bullseye"></i></div><span>Clique por abertura</span><strong>{{ clickToOpenRate | number }}%</strong><small>Engajamento do conteúdo</small></article>
      </div>

      <div class="report-layout">
        <article class="engagement-card">
          <header><div><span>Funil de engajamento</span><h3>Jornada automatizada</h3></div><i class="fas fa-project-diagram"></i></header>
          <div class="funnel-list">
            <div class="funnel-row"><div class="funnel-label"><i class="far fa-paper-plane"></i><span>Enviadas</span><strong>{{ stats.total | number }}</strong></div><div class="progress-track"><span style="width: 100%"></span></div><small>100%</small></div>
            <div class="funnel-row"><div class="funnel-label"><i class="far fa-envelope-open"></i><span>Abertas</span><strong>{{ stats.total_open | number }}</strong></div><div class="progress-track"><span :style="{ width: safePercent(stats.tax_open) + '%' }"></span></div><small>{{ stats.tax_open | number }}%</small></div>
            <div class="funnel-row"><div class="funnel-label"><i class="fas fa-mouse-pointer"></i><span>Clicadas</span><strong>{{ stats.total_click | number }}</strong></div><div class="progress-track"><span :style="{ width: safePercent(stats.tax_click) + '%' }"></span></div><small>{{ stats.tax_click | number }}%</small></div>
          </div>
          <div class="insight"><i class="far fa-lightbulb"></i><p><strong>{{ engagementLabel }}</strong><span>{{ engagementHint }}</span></p></div>
        </article>

        <article class="links-card">
          <header><div><span>Conteúdo</span><h3>Links mais acessados</h3></div><span class="count-pill">{{ links.length }} links</span></header>
          <div v-if="links.length" class="links-list">
            <div v-for="(link, index) in sortedLinks" :key="index" class="link-row">
              <span class="link-position">{{ index + 1 }}</span>
              <div class="link-data"><a :href="link.url" target="_blank" rel="noopener noreferrer" :title="link.url">{{ link.url }}</a><div class="link-progress"><span :style="{ width: linkShare(link.total) + '%' }"></span></div></div>
              <div class="link-clicks"><strong>{{ link.total | number }}</strong><span>cliques</span></div>
              <a :href="link.url" target="_blank" rel="noopener noreferrer" class="external-link" title="Abrir link"><i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>
          <div v-else class="links-empty"><i class="fas fa-link"></i><h4>Nenhum clique registrado</h4><p>Os links acessados aparecerão aqui.</p></div>
        </article>
      </div>
    </template>
  </section>
</template>

<script>
import { getTrackingAuto } from "@/services/tracking";

export default {
  name: "AutomationDetail",
  props: ["automation_id"],
  data() {
    return { loading: false, stats: { total: 0, tax_open: 0, total_open: 0, total_click: 0, tax_click: 0 }, links: [] };
  },
  computed: {
    clickToOpenRate() {
      return this.stats.total_open ? (Number(this.stats.total_click || 0) / Number(this.stats.total_open)) * 100 : 0;
    },
    sortedLinks() {
      return [...this.links].sort((a, b) => Number(b.total || 0) - Number(a.total || 0));
    },
    maxLinkClicks() {
      return this.sortedLinks.length ? Number(this.sortedLinks[0].total || 0) : 0;
    },
    engagementLabel() {
      return Number(this.stats.tax_open || 0) >= 20 ? "Boa taxa de abertura" : "Há espaço para melhorar";
    },
    engagementHint() {
      return Number(this.stats.tax_open || 0) >= 20 ? "A automação está conquistando a atenção dos contatos." : "Revise o assunto e o momento de envio das mensagens.";
    },
  },
  mounted() { this.getTrackingAuto(); },
  methods: {
    safePercent(value) { return Math.max(0, Math.min(100, Number(value || 0))); },
    linkShare(value) { return this.maxLinkClicks ? Math.max(4, (Number(value || 0) / this.maxLinkClicks) * 100) : 0; },
    getTrackingAuto() {
      if (this.loading) return;
      this.loading = true;
      getTrackingAuto(this.automation_id, {})
        .then((result) => { this.stats = result.stats; this.links = result.links || []; })
        .catch(() => this.$toast.error({ title: "Erro", message: "Não foi possível carregar o relatório." }))
        .finally(() => { this.loading = false; });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../performance-report";
</style>
